import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  useParams, useLocation
} from "react-router-dom";
import { useNavigate } from "react-router";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button, Card, CardContent, Tooltip, Typography } from "@mui/material";
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import TextInput from "../../common/TextInput";
import SelectDropdown from "../../common/FormSelectDropdown";
import FileUpload from "../../common/FileUpload";
import "v2/components/forms/EditProject/stylev2.css";
import { makeStyles } from '@mui/styles';
import { errorToast, successToast, warningToast } from "../../../utils/toast";
import { ToastContainer } from 'react-toastify';
import { useLoader } from "../../../../pages/LoaderContext";
import TextField from '@mui/material/TextField';
import DateCalendarValue from "../../common/Calander/Calander";
import InnoflexSaveModal from "../../common/InnoflexSaveModal"
import DeleteModal from "../../common/DelteModal"
import ValidationModal from "../../common/ValidationModal"
import UnSavedModal from "../../common/UnSavedModal"
import AutoSaveModal from "../../common/AutoSaveModal"
import QnAIcon from "../../../../assets/images/qna_icn.svg";
import uploadIcon from "../../../../assets/images/upload-icon.svg";
import circleArrowIcon from "../../../../assets/images/circle-arrow-icon.svg"


import useIdle from '../../../../hooks/useIdle';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Refresh } from "@mui/icons-material";
import { useProjectApiClient } from "../../../Services/api/projectService"
import { useInnoflexApiClient } from "../../../Services/api/InnoFlexService"
import { useApiClient } from "../../../Services/api/mileStoneService"
import { useAppContext } from '../../../../hooks/context/AppContext';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import useLocalStorage from "../../../../hooks/useLocalStorage";
import { projectVersion } from "config/navConfig";
import UploadList from "v2/components/common/UploadsList";

const useStyles = makeStyles({
  themeButton: {
    backgroundColor: '#2a3fbf !important',
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#2a3fbf !important' },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
  }
});


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '80%', // Set width to 80% of the screen
    maxWidth: 'none', // Remove the default maxWidth constraint
    minHeight: '200px',
    // maxHeight: '80vh',
    height: '90vh'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapSCDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '80%', // Set width to 80% of the screen
    maxWidth: 'none', // Remove the default maxWidth constraint
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));



type AuditEntry = {
  fieldName: string;
  oldValue: any;
  newValue: any;
  attributeId?: any;
};
interface ProjectPayload {
  project_id: string | undefined;
  project_name: string;
  project_attributes: any,
  sclead_key: string;
  subcategory_key: string;
  category_Key: string;
  brand_key: string;
  country_key: string;
  project_statuskey: string;
  big_bet: string;
  upload_pic: string;
  comment: string;
  risk_key: string;
  issaved: any;
  Launch_Quarter: string;
  Launch_Year: string;
  Bu_ID: string;
  Project_Exceptions: string;
  Format_Key: string;
  audit?: AuditEntry[]; // Add the optional audit property
}


let schema = yup.object().shape({
  projectName: yup.string().required("Project Name is required"),
  scLead: yup.string().required("SC Lead is required"),
  buid: yup.string().required("Business Unit is required"),
  country: yup.string(),
  category: yup.string().required("Category is required"),
  subCategory: yup.string().required("Master Brand is required"),
  brand: yup.string(),
  launchYear: yup.string(),
  launchWeek: yup.string(),
  projectStatus: yup.string().required("Project Status is required"),
  bigBet: yup.string(),
  uploadPic: yup.mixed(),
  risk: yup.string(),
  comment: yup.string(),
  format: yup.string().required("Format is required"),
  projectExpectation: yup.string(),
  brandsInfo: yup.object().shape({
    selectedBrand: yup.number().required(),
    list: yup.array().of(
      yup.object().shape({
        country_key: yup.string(),
        brand_key: yup.string().required("Brand is required"),
        Launch_Year: yup.string().required("Launch Year is required"),
        Launch_Quarter: yup.string().required("Launch Quarter is required")
      })
    )
  })
});

const ProjectForm: React.FC = () => {
  const location = useLocation();
  const { getInnoflexPhases, getInnoflexList, getSCList, postInnoflex, getInnoflex, getScPhases, postSc, getScData } = useInnoflexApiClient();
  const { getProjectDetails, getLaunchQuarter, getFormat, getLaunchYears, getLaunchMonth, getSclead, getBigbets, getRisks, getProjectStatus, getHCGlobalFilters, uploadImage, uploadProjectFile, getProjectFiles, createProject, createV2Project, getRequiredField } = useProjectApiClient();
  const {
    getMilestone,
    updateMilestone,
    getWeek
  } = useApiClient()

  const { appData, updateAppData, userData } = useAppContext();
  const { loading, setLoading } = useLoader();
  const isViewMode = window.location.pathname.includes('/view');
  const [isDisabled, setIsDisabled] = useState(true);
  const [scOpen, setScOpen] = React.useState<boolean>(false);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const isIdle = useIdle(60000 * 10);
  const hasAutoSaved = useRef(false);
  const [projectDetails, setProjectDetails] = useLocalStorage("ProjectDetails", null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showMilestoneModal, setShowMilestoneModal] = React.useState<boolean>(false);


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit)
    }
  }, [userData]);


  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);



  const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();
  const navigate = useNavigate();
  const classes = useStyles();

  const [scLeads, setScLeads] = useState([])
  const [countries, setCountries] = useState([])
  const [buids, setBuids] = useState([])
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [brands, setBrands] = useState([])
  const [launchYears, setLaunchYears] = useState([])
  const [launchMonths, setLaunchMonths] = useState([])
  const [launchWeeks, setLaunchWeeks] = useState([])
  const [launchWeeksOption, setLaunchWeeksOptions] = useState([])
  const [projectStatus, setProjectStatus] = useState([])
  const [bigBets, setBigBets] = useState([])
  const [risks, setRisks] = useState([])
  const [isInitial, setIsInitial] = useState(true)
  const [open, setOpen] = React.useState<boolean>(false);
  const [openCalendar, setOpenCalendar] = useState<string | null>(null);
  const [innoflexStages, setInnoflexStages] = useState([])
  const [innoflexList, setInnoflexList] = useState([])
  const [scStages, setScStages] = useState([])
  const [innoflexQuestions, setInnoflexQuestions] = useState({})
  const [validationErrors, setValidationErrors] = useState({})
  const [activeInnoflexStage, setActiveInnoflexStage] = useState(0)
  const [activeScStage, setActiveScStage] = useState(0)
  const [formats, setFormats] = useState([])
  const [scList, setSClist] = useState([])
  const [innoflexSuccessModal, setInnoflexSuccessModal] = React.useState(false);
  const [isValidationError, setIsValidationError] = useState(false)
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [issavedData, setIssavedData] = useState(false)
  const [innoflexResetIndex, setInoflexReset] = useState<any | null>([])
  const [scResetIndex, setScReset] = useState<any | null>([])
  const [imagePreview, setImagePreview] = useState('');
  const [formData, setFormData] = useState({
    projectName: '',
    scLead: '',
    buid: '',
    country: '',
    category: '',
    subCategory: '',
    brand: '',
    launchYear: '',
    launchWeek: '',
    projectStatus: '',
    bigBet: '',
    uploadPic: '',
    risk: '',
    comment: '',
    format: '',
    projectExpectation: '',
    issaved: false,
    brandsInfo: {
      selectedBrand: 0,
      list: [
        {
          toSaveMileStone: true,
          attributeId: null,
          "brand_key": "",
          "country_key": "",
          "Launch_Quarter": "",
          "Launch_Year": ""
        }
      ]
    }
  })

  const [initialformData, setInitialformData] = useState({
    projectName: '',
    scLead: '',
    buid: '',
    country: '',
    category: '',
    subCategory: '',
    brand: '',
    launchYear: '',
    launchWeek: '',
    projectStatus: '',
    bigBet: '',
    uploadPic: '',
    risk: '',
    comment: '',
    format: '',
    projectExpectation: '',
    issaved: false,
    brandsInfo: {
      selectedBrand: 0,
      list: [
        {
          toSaveMileStone: true,
          attributeId: null,
          "brand_key": "",
          "country_key": "",
          "Launch_Quarter": "",
          "Launch_Year": ""
        }
      ]
    }

  })
  const [mileStoneData, setMilestoneData] = useState({
    "SIW": '',
    "Product_Lock": '',
    "Product_Lock_Date": '',
    "BCSignOff_CP": '',
    "BCSignOff_CP_Date": '',
    "MPTProductValidation": '',
    "MPTProductValidation_Date": '',
    "FirstProduction": '',
    "FirstProduction_Date": '',
    "Comment": '',
    "Risk_Key": '',
    "Launch_Year": '',
    "Launch_Week": '',
  })


  const {
    handleSubmit,
    control,
    clearErrors,
    formState: { errors },
    reset,
    watch,
    setValue,
    trigger,
    setError
  } = useForm({
    defaultValues: formData,
    // @ts-ignore
    resolver: yupResolver(schema),
  });



  useEffect(() => {
    let check = JSON.stringify(formData) == JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }
  }, [formData]);


  useEffect(() => {

    const fetchOptions = async () => {
      setLoading(true)
      await Promise.all([
        fetchscLeads(),
        fetchBigbets(),
        fetchRisks(),
        fetchProjectStatus(),
        fetchYears(),
        fetchMonths(),
        fetchGlobalFilters('all', '0'),
        getInnoflexPhasesData(),
        getSCPhasesData(),
        fetchFormat(),
        fetchQuarters(),
        fetchinnoflexList(),
        fetchScList(),
      ]);
    };
    fetchOptions();
    window.setTimeout(() => {
      const searchParams = new URLSearchParams(location.search);
      const uploadFlag = searchParams.get("isUpload") === "true";
     // if (uploadFlag) return
      fetchsProjectDetails()

    }, 2000);

  }, []);

  useEffect(() => {
    if (formData.buid) {
      fetchGlobalFilters('buid', formData.buid)
    }
  }, [formData.buid]);

  // useEffect(() => {
  //   if (formData.country) {
  //     fetchGlobalFilters('country', formData.country)
  //   }
  // }, [formData.country]);

  useEffect(() => {
    if (formData.category) {
      fetchGlobalFilters('category', formData.category)

    }
  }, [formData.category]);

  useEffect(() => {
    if (formData.subCategory) {
      fetchGlobalFilters('subCategory', formData.subCategory)
    }
  }, [formData.subCategory]);

  useEffect(() => {
    if (formData) {
      reset(formData);
    }
  }, [formData, reset]);

  useEffect(() => {
    // @ts-ignore
    reset(formData);
    // @ts-ignore
  }, [formData, formData.projectName, scStages[activeScStage]], innoflexStages[activeInnoflexStage]);

  useEffect(() => {
    if (innoflexStages.length > 0) {
      // @ts-ignore
      getInnoflexAnswers(innoflexStages[activeInnoflexStage].InnoflexPhase_key);
    }
  }, [innoflexStages, activeInnoflexStage]);


  useEffect(() => {
    if (scStages.length) {
      // @ts-ignore
      fetchSCdata(scStages[activeScStage].SCPhase_key, scStages[activeScStage].SCPhasevalue)
    }

  }, [projectKey, activeScStage]);

  const isEmptyObject = (obj: object) => {
    return JSON.stringify(obj) === '{}'
  };

  const fetchMilestoneDetails = async (key: string, listData: any) => {
    try {
      const data = await getMilestone(key);
      if (isEmptyObject(data.data)) return
      setMilestoneData({
        "SIW": data.data.SIW,
        "Product_Lock": data.data.Product_Lock,
        "Product_Lock_Date": data.data.Product_Lock_Date,
        "BCSignOff_CP": data.data.BCSignOff_CP,
        "BCSignOff_CP_Date": data.data.BCSignOff_CP_Date,
        "MPTProductValidation": data.data.MPTProductValidation,
        "MPTProductValidation_Date": data.data.MPTProductValidation_Date,
        "FirstProduction": data.data.FirstProduction,
        "FirstProduction_Date": data.data.FirstProduction_Date,
        "Comment": data.data.Comment,
        "Risk_Key": data.data.Risk_Key,
        "Launch_Year": listData?.find((attr: any) => attr.toSaveMileStone)?.Launch_Year ? JSON.stringify(listData?.find((attr: any) => attr.toSaveMileStone)?.Launch_Year) : '',
        "Launch_Week": '',

      })
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  const convertAttributeArray = (data: any) => {
    return data.map((item: any) => ({
      attributeId: item.attributeId,
      toSaveMileStone: item.toSaveMileStone,
      brand_key: item.brand_key ? String(item.brand_key) : "",
      country_key: item.country_key ? String(item.country_key) : "",
      Launch_Quarter: item.Launch_Quarter ? String(item.Launch_Quarter) : "",
      Launch_Year: item.Launch_Year ? String(item.Launch_Year) : ""
    }));
  };

  const fetchsProjectDetails = async () => {
    try {
      setLoading(true)
      const data = await getProjectDetails(projectId);
      setIsInitial(false)
      if (data) {
        const year = data.project_attributes.length ? data.project_attributes.find((item: any) => item.toSaveMileStone)?.Launch_Year : ''
        const quarter = data.project_attributes.length ? data.project_attributes.find((item: any) => item.toSaveMileStone)?.Launch_Quarter : ''

        fetchWeeks(year, quarter)
        let projectData = {
          buid: data.BU_ID ? JSON.stringify(data.BU_ID) : '',
          projectName: data.name,
          uploadPic: data.upload_pic ? data.upload_pic : '',
          scLead: data.sclead_key ? JSON.stringify(data.sclead_key) : '',
          country: data.country_key ? JSON.stringify(data.country_key) : '',
          category: data.category_Key ? JSON.stringify(data.category_Key) : '',
          subCategory: data.subcategory_key ? JSON.stringify(data.subcategory_key) : '',
          brand: data.brand_key ? JSON.stringify(data.brand_key) : '',
          launchYear: data.Launch_Year ? JSON.stringify(data.Launch_Year) : '',
          launchWeek: data.Launch_Quarter ? JSON.stringify(data.Launch_Quarter) : '',
          projectStatus: data.project_statuskey ? JSON.stringify(data.project_statuskey) : '',
          bigBet: data.big_bet == true ? '1' : '2',
          risk: data.risk_key ? JSON.stringify(data.risk_key) : '',
          comment: data.comment,
          projectExpectation: data.Project_Exceptions ? data.Project_Exceptions : '',
          format: data.Format_Key ? JSON.stringify(data.Format_Key) : '',
          issaved: data.issaved,
          brandsInfo: {
            // @ts-ignore
            selectedBrand: data.project_attributes.length ? data.project_attributes?.findIndex((item: any) => item.toSaveMileStone) : 0,
            list: data.project_attributes?.length ? [...convertAttributeArray(data.project_attributes)] : formData.brandsInfo.list
          }
        }
        setFormData(projectData)
        setInitialformData(projectData)
        setIsDraftDisabled(projectData.issaved)
        setProjectDetails(JSON.stringify({ projectName: projectData.projectName, projectId, }));
        if (projectKey) {
          fetchMilestoneDetails(projectKey, data.project_attributes)
        }
        if (data.upload_pic) {
          setImagePreview(data.upload_pic)
        }
        // @ts-ignore
        // setProjectKey(data.project_key || "");
        // setProjectids(projectId || ""); 
      }
    } catch (error) {
      setLoading(false)
      console.error(" Failed to fetch projects:", error);
    } finally {
      setLoading(false)
    }
  };
  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };


  const getCompleteAuditTrail = (
    initialData: Record<string, any>,
    updatedData: Record<string, any>
  ): AuditEntry[] => {
    const audit: AuditEntry[] = [];

    // Step 1: Handle top-level keys except project_attributes
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === "project_id" || key === "project_attributes") continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue ?? ""),
        newValue: String(newValue ?? "")
      });
    }

    // Step 2: Handle project_attributes comparison
    if (Array.isArray(initialData.project_attributes) && Array.isArray(updatedData.project_attributes)) {
      updatedData.project_attributes.forEach((updatedAttr, index) => {
        const initialAttr = initialData.project_attributes[index] || {};

        Object.keys(updatedAttr).forEach((field) => {
          if (field === "attributeId") return; // skip ID itself
          const oldVal = initialAttr[field] ?? null;
          const newVal = updatedAttr[field] ?? null;

          audit.push({
            attributeId: updatedAttr.attributeId,
            fieldName: field,
            oldValue: oldVal,
            newValue: newVal
          });
        });
      });
    }

    return audit;
  };

  function checkMilestoneChange(formData: any, initialFormData: any) {
    const formIndex = formData.findIndex((obj: any) => obj.toSaveMileStone);
    const initialIndex = initialFormData.findIndex((obj: any) => obj.toSaveMileStone);
    let isChanged = false;
    if (formIndex === -1 || initialIndex === -1) {
      return false;
    }
    if (formIndex !== initialIndex) {
      return true;
    }
    const formObj = formData[formIndex];
    const initialObj = initialFormData[initialIndex];
    if (
      formObj.Launch_Quarter !== initialObj.Launch_Quarter ||
      formObj.Launch_Year !== initialObj.Launch_Year
    ) {
      return true;
    }
    return false;
  }


  const saveProject = async (data: any, type: any, url?: string) => {
    try {

      try {
        await schema.validate(formData, { abortEarly: false });
      }
      catch (validationError: any) {
        if (validationError.inner) {
          validationError.inner.forEach((err: any) => {
            setError(err.path, { type: "manual", message: err.message });
          });
        }
        return;
      }

      // 1. Check required fields from API
      const resField = await fetchRequiredField();
      if (
        resField?.data &&
        resField?.data.filter((val: any) => val.ModuleName !== "Project Information").length
      ) {
        const groupedErrors = groupByModule(
          resField.data.filter((val: any) => val.ModuleName !== "Project Information")
        );
        setValidationErrors(groupedErrors);
        setIsValidationError(true);
        return;
      }
      // 2. Validate mandatory local field
      if (!formData.projectName) {
        setError("projectName", {
          type: "required",
          message: "Project Name is required",
        });
        return;
      }
      let isChanged = checkMilestoneChange(formData.brandsInfo.list, initialformData.brandsInfo.list)
      if (isChanged) {
        setShowMilestoneModal(true)
        return
      }
      setLoading(true);
      // 3. Prepare payload
      const payload: ProjectPayload = {
        project_id: projectId,
        project_name: formData.projectName,
        project_attributes: formData.brandsInfo.list,
        sclead_key: formData.scLead,
        subcategory_key: formData.subCategory,
        category_Key: formData.category,
        brand_key: formData.brand,
        country_key: formData.country,
        project_statuskey: formData.projectStatus,
        big_bet: formData.bigBet,
        upload_pic: formData.uploadPic,
        comment: formData.comment,
        risk_key: formData.risk,
        issaved: true,
        Launch_Quarter: formData.launchWeek,
        Launch_Year: formData.launchYear,
        Bu_ID: formData.buid,
        Project_Exceptions: formData.projectExpectation,
        Format_Key: formData.format,
      };
      // 4. Prepare audit trail
      const initialPayload: ProjectPayload = {
        project_id: projectId,
        project_name: initialformData.projectName,
        project_attributes: initialformData.brandsInfo.list,
        sclead_key: initialformData.scLead,
        subcategory_key: initialformData.subCategory,
        category_Key: initialformData.category,
        brand_key: initialformData.brand,
        country_key: initialformData.country,
        project_statuskey: initialformData.projectStatus,
        big_bet: initialformData.bigBet,
        upload_pic: initialformData.uploadPic,
        comment: initialformData.comment,
        risk_key: initialformData.risk,
        issaved: type === "submit",
        Launch_Quarter: initialformData.launchWeek,
        Launch_Year: initialformData.launchYear,
        Bu_ID: initialformData.buid,
        Project_Exceptions: initialformData.projectExpectation,
        Format_Key: initialformData.format,
      };
      payload.audit = getCompleteAuditTrail(initialPayload, payload);
      // 5. Include brand attributes audit
      const audit: any[] = [];
      const keysToTrack = [
        "projectName",
        "scLead",
        "subCategory",
        "category",
        "projectStatus",
        "bigBet",
        "uploadPic",
        "comment",
        "risk",
        "buid",
        "projectExpectation",
        "format",
      ];
      keysToTrack.forEach((key) => {
        const formKeyMap: any = {
          projectName: "project_name",
          scLead: "sclead_key",
          subCategory: "subcategory_key",
          category: "category_Key",
          projectStatus: "project_statuskey",
          bigBet: "big_bet",
          uploadPic: "upload_pic",
          risk: "risk_key",
          buid: "Bu_ID",
          projectExpectation: "Project_Exceptions",
          format: "Format_Key",
        };
        audit.push({
          fieldName: formKeyMap[key] || key,
          // @ts-ignore
          oldValue: initialformData[key] ?? "", newValue: formData[key] ?? "",
        });
      });
      formData.brandsInfo.list.forEach((attr, index) => {
        const initialAttr = initialformData.brandsInfo.list[index] || {};
        Object.keys(attr).forEach((field) => {
          audit.push({
            attributeId: index + 1,
            fieldName: field,
            // @ts-ignore
            oldValue: initialAttr[field], newValue: attr[field],
          });
        });
      });

      // 6. Add audit to payload
      payload.audit = audit;
      // 7. Call API
      const res = await createV2Project(payload);
      setLoading(false);
      if (res) {
        fetchsProjectDetails();
        updateAppData({ isFormChanged: false, showUnSavedModal: false });
        successToast(res.message);
        setIssavedData(true);
        setIsDraftDisabled(true);

        setTimeout(() => {
          navigate(
            url
              ? url
              : type === "submit"
                ? `/project/project-info/${res?.project?.project_id}/${res?.project?.project_key}`
                : `${projectVersion}/project/milestones/${res?.project?.project_id}/${res?.project?.project_key}`
          );
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error saving project:", error);
    }
  };

  const saveProjectwithMileStone = async () => {
    setShowMilestoneModal(false)
    setLoading(true);
    // 3. Prepare payload
    const payload: ProjectPayload = {
      project_id: projectId,
      project_name: formData.projectName,
      project_attributes: formData.brandsInfo.list,
      sclead_key: formData.scLead,
      subcategory_key: formData.subCategory,
      category_Key: formData.category,
      brand_key: formData.brand,
      country_key: formData.country,
      project_statuskey: formData.projectStatus,
      big_bet: formData.bigBet,
      upload_pic: formData.uploadPic,
      comment: formData.comment,
      risk_key: formData.risk,
      issaved: true,
      Launch_Quarter: formData.launchWeek,
      Launch_Year: formData.launchYear,
      Bu_ID: formData.buid,
      Project_Exceptions: formData.projectExpectation,
      Format_Key: formData.format,
    };
    // 4. Prepare audit trail
    const initialPayload: ProjectPayload = {
      project_id: projectId,
      project_name: initialformData.projectName,
      project_attributes: initialformData.brandsInfo.list,
      sclead_key: initialformData.scLead,
      subcategory_key: initialformData.subCategory,
      category_Key: initialformData.category,
      brand_key: initialformData.brand,
      country_key: initialformData.country,
      project_statuskey: initialformData.projectStatus,
      big_bet: initialformData.bigBet,
      upload_pic: initialformData.uploadPic,
      comment: initialformData.comment,
      risk_key: initialformData.risk,
      issaved: true,
      Launch_Quarter: initialformData.launchWeek,
      Launch_Year: initialformData.launchYear,
      Bu_ID: initialformData.buid,
      Project_Exceptions: initialformData.projectExpectation,
      Format_Key: initialformData.format,
    };
    payload.audit = getCompleteAuditTrail(initialPayload, payload);
    // 5. Include brand attributes audit
    const audit: any[] = [];
    const keysToTrack = [
      "projectName",
      "scLead",
      "subCategory",
      "category",
      "projectStatus",
      "bigBet",
      "uploadPic",
      "comment",
      "risk",
      "buid",
      "projectExpectation",
      "format",
    ];
    keysToTrack.forEach((key) => {
      const formKeyMap: any = {
        projectName: "project_name",
        scLead: "sclead_key",
        subCategory: "subcategory_key",
        category: "category_Key",
        projectStatus: "project_statuskey",
        bigBet: "big_bet",
        uploadPic: "upload_pic",
        risk: "risk_key",
        buid: "Bu_ID",
        projectExpectation: "Project_Exceptions",
        format: "Format_Key",
      };
      audit.push({
        fieldName: formKeyMap[key] || key,
        // @ts-ignore
        oldValue: initialformData[key] ?? "", newValue: formData[key] ?? "",
      });
    });
    formData.brandsInfo.list.forEach((attr, index) => {
      const initialAttr = initialformData.brandsInfo.list[index] || {};
      Object.keys(attr).forEach((field) => {
        audit.push({
          attributeId: index + 1,
          fieldName: field,
          // @ts-ignore
          oldValue: initialAttr[field], newValue: attr[field],
        });
      });
    });

    // 6. Add audit to payload
    payload.audit = audit;
    // 7. Call API
    const res = await createV2Project(payload);
    saveMileStoneData()
    setLoading(false);
    if (res) {
      fetchsProjectDetails();
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
      successToast(res.message);
      setIssavedData(true);
      setIsDraftDisabled(true);

      setTimeout(() => {
        navigate(`${projectVersion}/project/milestones/${res?.project?.project_id}/${res?.project?.project_key}`);
      }, 1000);
    }
  }

  let saveMileStoneData = async () => {
    if (projectKey) {
      let res = await updateMilestone(mileStoneData, projectKey)
      console.log("ressss millw4", res)
    }

  }

  const onSubmit = async (data: any, type: any, url: string) => {
    let resField = await fetchRequiredField()
    if (resField?.data && resField?.data.filter((val: any) => val.ModuleName !== 'Project Information').length) {
      const groupedErrors = groupByModule(resField?.data.filter((val: any) => val.ModuleName !== 'Project Information'));
      setValidationErrors(groupedErrors)
      setIsValidationError(true)
      return
    }
    setLoading(true)
    let payload: ProjectPayload = {
      "project_id": projectId,
      "project_name": formData.projectName,
      "project_attributes": formData.brandsInfo.list,
      "sclead_key": formData.scLead,
      "subcategory_key": formData.subCategory,
      "category_Key": formData.category,
      "brand_key": formData.brand,
      "country_key": formData.country,
      "project_statuskey": formData.projectStatus,
      "big_bet": formData.bigBet,
      "upload_pic": formData.uploadPic,
      "comment": formData.comment,
      "risk_key": formData.risk,
      "issaved": type,
      "Launch_Quarter": formData.launchWeek,
      "Launch_Year": formData.launchYear,
      "Bu_ID": formData.buid,
      "Project_Exceptions": formData.projectExpectation,
      "Format_Key": formData.format
    }

    let initialPayload: ProjectPayload = {
      "project_id": projectId,
      "project_name": initialformData.projectName,
      "project_attributes": initialformData.brandsInfo.list,
      "sclead_key": initialformData.scLead,
      "subcategory_key": initialformData.subCategory,
      "category_Key": initialformData.category,
      "brand_key": initialformData.brand,
      "country_key": initialformData.country,
      "project_statuskey": initialformData.projectStatus,
      "big_bet": initialformData.bigBet,
      "upload_pic": initialformData.uploadPic,
      "comment": initialformData.comment,
      "risk_key": initialformData.risk,
      "issaved": type,
      "Launch_Quarter": initialformData.launchWeek,
      "Launch_Year": initialformData.launchYear,
      "Bu_ID": initialformData.buid,
      "Project_Exceptions": initialformData.projectExpectation,
      "Format_Key": initialformData.format
    }
    console.log({ payload });
    const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
    payload.audit = completeAuditTrail;

    let res = await createV2Project(payload)

    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    setLoading(false)
    if (res) {
      fetchsProjectDetails()
      setIssavedData(true)
      setIsDraftDisabled(true);
      successToast(res.message)
      setTimeout(() => {
        navigate(url ? url : `${projectVersion}/project/project-info/${res?.project?.project_id}/${res?.project?.project_key}`)
      }, 1000);
    }
  };

  let saveDraft = async (url: string) => {
    if (!formData.projectName) {
      setError("projectName", {
        type: "required",
        message: "Project Name is required",
      });
      return;
    }
    setLoading(true)
    const audit: any[] = [];
    const keysToTrack = [
      "projectName",
      "scLead",
      "subCategory",
      "category",
      "projectStatus",
      "bigBet",
      "uploadPic",
      "comment",
      "risk",
      "issaved",
      "buid",
      "projectExpectation",
      "format",
    ];

    keysToTrack.forEach((key) => {
      const formKey =
        key === "projectName"
          ? "project_name"
          : key === "scLead"
            ? "sclead_key"
            : key === "subCategory"
              ? "subcategory_key"
              : key === "category"
                ? "category_Key"
                : key === "projectStatus"
                  ? "project_statuskey"
                  : key === "bigBet"
                    ? "big_bet"
                    : key === "uploadPic"
                      ? "upload_pic"
                      : key === "risk"
                        ? "risk_key"
                        : key === "buid"
                          ? "Bu_ID"
                          : key === "projectExpectation"
                            ? "Project_Exceptions"
                            : key === "format"
                              ? "Format_Key"
                              : key;

      audit.push({
        fieldName: formKey,
        // @ts-ignore
        oldValue: initialformData[key] ?? "", newValue: formData[key] ?? "",
      });
    });

    formData.brandsInfo.list.forEach((attr, index) => {
      const initialAttr = initialformData.brandsInfo.list[index] || {};
      Object.keys(attr).forEach((field) => {
        audit.push({
          attributeId: index + 1,
          fieldName: field,
          // @ts-ignore
          oldValue: initialAttr[field], newValue: attr[field],
        });
      });
    });

    let payload = {
      project_id: projectId,
      project_name: formData.projectName,
      project_attributes: formData.brandsInfo.list.filter(item =>
        item.country_key || item.brand_key || item.Launch_Year || item.Launch_Quarter
      ),
      sclead_key: formData.scLead,
      subcategory_key: formData.subCategory,
      category_Key: formData.category,
      project_statuskey: formData.projectStatus,
      big_bet: formData.bigBet,
      upload_pic: formData.uploadPic,
      comment: formData.comment,
      risk_key: formData.risk,
      issaved: false,
      Bu_ID: formData.buid,
      Project_Exceptions: formData.projectExpectation,
      Format_Key: formData.format,
      audit,
    };
    let res = await createV2Project(payload);
    setLoading(false);

    if (res) {
      fetchsProjectDetails();
      successToast(res.message);
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
      setTimeout(() => {
        navigate(
          url
            ? url
            : `${projectVersion}/project/milestones/${res?.project?.project_id}/${res?.project?.project_key}`
        );
      }, 1000);
    }
  };

  const fetchFormat = async () => {
    try {
      const data = await getFormat();
      // @ts-ignore
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setFormats(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchscLeads = async () => {
    try {
      const data = await getSclead();
      let output = data.map((item: any) => ({
        key: item.sclead_key,
        value: item.sclead_name
      }));
      setScLeads(output)
    } catch (error) {

      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  const fetchYears = async () => {
    try {
      const data = await getLaunchYears();
      let output = data.map((item: any) => ({
        key: item.launchYears_key,
        value: item.launchYears_value
      }));
      // @ts-ignore
      setLaunchYears(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchMonths = async () => {
    try {
      const data = await getLaunchMonth();
      let output = data.map((item: any) => ({
        key: item.Launch_Month,
        value: item.Launch_MonthName
      }));
      // @ts-ignore
      setLaunchMonths(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchQuarters = async () => {
    try {
      const data = await getLaunchQuarter();
      let output = data.map((item: any) => ({
        key: item.Launch_Quarter,
        value: item.Launch_QuarterName
      }));
      // @ts-ignore
      setLaunchWeeks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchWeeks = async (year: any, quarter: any) => {
    try {
      const data = await getWeek(year, quarter);
      let output = data.data.map((item: any) => ({
        key: item.Launch_Week,
        value: item.Launch_WeekName
      }));
      // @ts-ignore
      setLaunchWeeksOptions(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchBigbets = async () => {
    try {
      const data = await getBigbets();
      let output = data.map((item: any) => ({
        key: item.bigbet_key,
        value: item.bigbetdescription
      }));
      // @ts-ignore
      setBigBets(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchRisks = async () => {
    try {
      const data = await getRisks();
      let output = data.map((item: any) => ({
        key: item.Risk_key,
        value: item.Risk_name
      }));
      // @ts-ignore
      setRisks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchProjectStatus = async () => {
    try {
      const data = await getProjectStatus();
      let output = data.map((item: any) => ({
        key: item.projectStatus_key,
        value: item.projectStatusvalue
      }));
      // @ts-ignore
      setProjectStatus(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchSCdata = async (scKey: any, value: any) => {
    try {

      // @ts-ignore
      const data = await getScData(projectKey, scKey);
      if (data.data?.Last_Saved_Date) {
        setFormData({
          ...formData,
          [value]: formatDate(data.data.Last_Saved_Date)
        })
        setInitialformData({
          ...formData,
          [value]: formatDate(data.data.Last_Saved_Date)
        })
      }

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchGlobalFilters = async (filter: any, value: any) => {
    try {
      let payload = {

      }
      if (filter == 'all') {
        payload = {
          "buid": filter == 'all' ? [] : filter == 'buid' ? [parseInt(value)] : filter == 'country' || filter == 'category' || filter == 'subCategory' ? [parseInt(formData.buid)] : [],
          "countryKey": filter == 'all' ? [] : filter == 'country' ? [parseInt(value)] : filter == 'category' || filter == 'subCategory' ? [parseInt(formData.country)] : [],
          "categoryKey": filter == 'all' ? [] : filter == 'category' ? [parseInt(value)] : filter == 'subCategory' ? [parseInt(formData.category)] : [],
          "subCategoryKey": filter == 'all' ? [] : filter == 'subCategory' ? [parseInt(value)] : [],
          "brandKey": []
        }
      }
      else if (filter == 'buid') {
        payload = {
          "buid": filter == 'all' ? [] : filter == 'buid' ? [parseInt(value)] : filter == 'country' || filter == 'category' || filter == 'subCategory' ? [parseInt(formData.buid)] : []
        }
      }
      else {
        payload = {
          "categoryKey": filter == 'all' ? [] : filter == 'category' ? [parseInt(value)] : filter == 'subCategory' ? [parseInt(formData.category)] : [],
          "subCategoryKey": filter == 'all' ? [] : filter == 'subCategory' ? [parseInt(value)] : [],
        }
      }

      // @ts-ignore
      const data = await getHCGlobalFilters(payload);
      // @ts-ignore
      if (data.data) {
        if (filter == 'all') {
          // @ts-ignore
          setBuids(data?.data.bu); setCountries(data?.data.country); setCategories(data.data.category); setSubCategories(data?.data.subCategory); setBrands(data?.data?.brand)
        }
        else if (filter == 'buid') {
          // @ts-ignore
          setCountries(data?.data.country);

        }
        // else if (filter == 'country') {
        //   // @ts-ignore
        //   setCategories(data.data.category); setSubCategories(data?.data.subCategory); setBrands(data?.data?.brand)
        // }
        else if (filter == 'category') {
          // @ts-ignore
          setSubCategories(data?.data.subCategory); //setBrands(data?.data?.brands)
        }
        else if (filter == 'subCategory') {
          // @ts-ignore
          setBrands(data?.data?.brand)
        }
        else if (filter == 'brand') {
          // @ts-ignore
          //  setBrands(data?.data?.brand)
        }
      }

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  // const handleFileChange = async (file: any) => {
  //   if (!file) return
  //   setImagePreview(URL.createObjectURL(file))
  //   const formdata = new FormData();
  //   formdata.append("image", file, file.name);
  //   let data = await uploadImage(formdata)
  //   setFormData({
  //     ...formData,
  //     uploadPic: data.filename
  //   })
  // };

  const handleFileChange = async (file: any) => {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only JPEG, JPG, or PNG formats are allowed.');
      return;
    }
    setLoading(true)
    //if (!file) return;
    // Validate file size (5 MB maximum)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('Image size must be less than 5 MB');
      return;
    }
    try {
      setImagePreview(URL.createObjectURL(file));
      const formdata = new FormData();
      formdata.append("image", file, file.name);
      let data = await uploadImage(formdata);

      setFormData({
        ...formData,
        uploadPic: data.filename
      });
      setLoading(false)
    } catch (error) {
      console.error('Error uploading image:', error);
      errorToast('Failed to upload image. Please try again.');
    }
  };
  const handleProjectFileChange = async (file: any, event?: React.ChangeEvent<HTMLInputElement>) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-powerpoint", // .ppt
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
    ];

    if (!allowedTypes.includes(file.type)) {
      errorToast("Only PDF, PPT, XLS or DOC formats are allowed.");
      event && (event.target.value = ""); // reset file input
      return;
    }

    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
    if (file.size > MAX_FILE_SIZE) {
      errorToast("File size must be less than 5 MB");
      event && (event.target.value = "");
      return;
    }

    try {
      setLoading(true);
      const formdata = new FormData();
      formdata.append("file", file, file.name);

      let data = await uploadProjectFile(projectKey, 1, formdata);
      // successToast(data.message)
      setRefreshTrigger((prev) => prev + 1);
    } catch (error) {
      console.error("Error uploading file:", error);
      errorToast("Failed to upload file. Please try again.");
    } finally {
      setLoading(false);
      event && (event.target.value = ""); // clear input for next upload
    }
  };


  const handleRemoveImg = (file: any) => {
    if (isDisabled) return
    setImagePreview('')
    setFormData({
      ...formData,
      uploadPic: ''
    })
  };

  let handleFormChange = (name: any, value: any) => {
    hasAutoSaved.current = false;
    clearErrors(name)
    setFormData({
      ...formData,
      [name]: value
    })
  }

  let handleFilterChange = async (name: any, value: any) => {
    hasAutoSaved.current = false;
    let data = { ...formData, [name]: value }
    if (name == 'buid') {
      // data = { ...formData, [name]: value, country: '', category: '', subCategory: '', brand: '' }
      let updatedAttribute = { list: formData?.brandsInfo?.list.map(o => ({ ...o, country_key: "" })), selectedBrand: formData.brandsInfo.selectedBrand }
      {/* @ts-ignore */ }
      data = { ...formData, [name]: value, country: '', brandsInfo: updatedAttribute }
    }
    else if (name == 'country') {
      data = { ...formData, [name]: value }
    }
    else if (name == 'category') {
      data = {
        ...formData,
        [name]: value,
        subCategory: '',
        brand: '',
        brandsInfo: {
          ...formData.brandsInfo,
          list: formData.brandsInfo.list.map(item => ({
            ...item,
            brand_key: ""
          }))
        }
      }
    }
    else if (name == 'subCategory') {
      data = {
        ...formData, [name]: value, brand: '', brandsInfo: {
          ...formData.brandsInfo,
          list: formData.brandsInfo.list.map(item => ({
            ...item,
            brand_key: ""
          }))
        }
      }
    }
    else {
      data = { ...formData, [name]: value }
    }
    setFormData(data)
  }


  const [formate, setFormate] = React.useState('');

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setFormate(event.target.value);
  };

  const handleClickOpen = () => {
    if (isDisabled) return
    setOpen(true);
    {/* @ts-ignore */ }
    getInnoflexAnswers(innoflexStages[activeInnoflexStage].InnoflexPhase_key)
    const updatedFormData = { ...formData };
    innoflexStages.forEach((item, i) => {
      {/* @ts-ignore */ }
      updatedFormData[item.InnoflexPhasevalue] = innoflexList[i].Phase_Start_Date ? formatDate(innoflexList[i].Phase_Start_Date) : null

    });
    setFormData(updatedFormData);
    setInitialformData(updatedFormData)

  };


  const handleClose = () => {
    setOpen(false);
  };

  // const handleDateSelect = (date: string, fieldName: string) => {
  //   {/* @ts-ignore */ }
  //   const formattedDate = date.format('DD-MM-YYYY'); setValue(fieldName, formattedDate); trigger(fieldName);
  //   setOpenCalendar(null);
  // };

  const handleDateSelect = (date: any | null, fieldName: string) => {
    const formattedDate = date ? date.format('DD-MM-YYYY') : null;
    {/* @ts-ignore */ }
    setValue(fieldName, formattedDate); trigger(fieldName);
    setOpenCalendar(null);
  };

  const toggleCalendar = (calendarId: any, val: any, phase: any) => {
    if ((phase == 'innoflex' ? val.Innoflex_Phase_Key : val.SCPhase_key) != (phase == 'innoflex' ? activeInnoflexStage + 1 : activeScStage + 1)) return
    setOpenCalendar((prev) => (prev === calendarId ? null : calendarId));

  };

  const addDynamicFields = (newSchema: any, phases: any, type: any): any => {
    const dynamicFields: Record<string, yup.StringSchema<string>> = {};
    phases.forEach((phase: any) => {

      if (type == 'sc') {
        // @ts-ignore
        dynamicFields[phase.SCPhasevalue] = yup.string();
      } else {
        // @ts-ignore
        dynamicFields[phase.InnoflexPhasevalue] = yup.string();
      }

    });
    return newSchema.concat(yup.object().shape(dynamicFields));
  };

  const getInnoflexPhasesData = async () => {
    try {
      const data = await getInnoflexPhases();
      schema = addDynamicFields(schema, data, 'innoflex');
      if (data) {
        setInnoflexStages(data);
      }
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };

  const fetchinnoflexList = async () => {
    try {
      const data = await getInnoflexList(projectKey);
      if (data.data) {
        setInnoflexList(data.data)
      }

    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };

  const fetchScList = async () => {
    try {
      const data = await getSCList(projectKey);
      if (data.data) {
        setSClist(data.data)
      }

    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };




  const getSCPhasesData = async () => {
    try {
      const data = await getScPhases();
      schema = addDynamicFields(schema, data, 'sc');
      if (data) {
        setScStages(data);
      }
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };

  const getInnoflexAnswers = async (phaseKey: number) => {
    {/* @ts-ignore */ }
    let inKey = innoflexStages[activeInnoflexStage].InnoflexPhasevalue
    try {
      {/* @ts-ignore */ }
      const data = await getInnoflex(projectKey, phaseKey);
      if (data.data) {
        setInnoflexQuestions(data.data)
        if (data.data.Last_Saved_Date) {
        }

      }

    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };


  function updatePhaseOptionsStatus(obj: any, arr: any, ans: number) {
    return arr.map((item: any) => {
      if (item.Innoflex_Phase_Options_Key === obj.Innoflex_Phase_Options_Key) {
        return {
          ...item,
          Innoflex_Phase_Options_Status: ans
        };
      }
      return item;
    });
  }

  let handleAnswerSelect = (val: any, ans: number) => {
    // @ts-ignore
    let temp = { ...innoflexQuestions }
    // @ts-ignore
    const updatedArray = updatePhaseOptionsStatus(val, innoflexQuestions.OptionsData, ans);
    // @ts-ignore
    temp.OptionsData = updatedArray
    setInnoflexQuestions(temp)

  }


  let handleInnoflexSave = async () => {
    setInnoflexSuccessModal(true)
    //@ts-ignore
    const outputDate = convertDateFormat(watch(innoflexStages[activeInnoflexStage].InnoflexPhasevalue)); let temp = []
    {/* @ts-ignore */ }
    innoflexQuestions.OptionsData.map((val, i) => {
      if (val.Innoflex_Phase_Options_Status == null) return
      let obj = {
        "Project_Key": projectKey,
        //@ts-ignore
        "Innoflex_Phase_Key": val.Innoflex_Phase_Key,
        "Innoflex_Phase_Options_Key": val.Innoflex_Phase_Options_Key,
        "Innoflex_Phase_Options_Status": val.Innoflex_Phase_Options_Status
      }
      temp.push(obj)
    })
    let payload = {
      "Phase_Start_Date": outputDate ? outputDate : '',
      //@ts-ignore
      "OptionsData": temp,
      "reset": innoflexResetIndex.includes(activeInnoflexStage) ? true : false
    }
    if (activeInnoflexStage == 0) {
      //@ts-ignore
      let res = await postInnoflex(payload, projectKey, innoflexStages[activeInnoflexStage].InnoflexPhase_key)
      setInoflexReset([])
      setInnoflexSuccessModal(false)
      setOpen(false)
      if (res) {
        successToast(res.message)
        fetchinnoflexList()
      }
    } else {
      //@ts-ignore
      let res = await postInnoflex(payload, projectKey, innoflexStages[activeInnoflexStage].InnoflexPhase_key)
      setInoflexReset([])
      setInnoflexSuccessModal(false)
      setOpen(false)
      if (res) {
        successToast(res.message)
        fetchinnoflexList()

      }
      // }
    }
  }

  let convertDateFormat = (dateStr: String) => {
    if (!dateStr) return
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  }

  let handleScSave = async () => {
    // @ts-ignore
    const outputDate = convertDateFormat(watch(scStages[activeScStage].SCPhasevalue));
    setInnoflexSuccessModal(true)
    let payload = {
      "Project_Key": projectKey,
      // @ts-ignore
      "SC_Phase_Key": scStages[activeScStage].SCPhase_key,
      "Phase_Start_Date": outputDate ? outputDate : '',
      "reset": scResetIndex.includes(activeScStage) ? true : false

    }
    // if (!payload.Phase_Start_Date) {
    //   setInnoflexSuccessModal(false)
    //   errorToast('Date is required')
    // }
    // else {
    {/* @ts-ignore */ }
    let res = await postSc(payload)
    setScReset([])
    setInnoflexSuccessModal(false)
    setScOpen(false)
    if (res) {
      fetchScList()
      successToast(res.message)
    }

  }

  let formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate
  }

  let openScdModal = () => {
    if (isDisabled) return
    setScOpen(true)
    {/* @ts-ignore */ }
    fetchSCdata(scStages[activeScStage].SCPhase_key, scStages[activeScStage].SCPhasevalue)
    const updatedFormData = { ...formData };

    scStages.forEach((item, i) => {
      {/* @ts-ignore */ }
      updatedFormData[item.SCPhasevalue] = scList[i].Phase_Start_Date ? formatDate(scList[i].Phase_Start_Date) : null

    });
    setFormData(updatedFormData);
    setInitialformData(updatedFormData)

  }

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: '' });
  }
  let saveUnSavedModal = () => {
    handleFormSubmit(true, appData.url)()
  }
  let draftSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    saveDraft(appData.url)
  }
  const discardModal = () => {
    // reset form, redirect, or just close modal
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    navigate(appData.url);
  };

  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }

  }

  let closeValidationModal = () => {
    setIsValidationError(false)
    setValidationErrors({})
  }

  let closeAutoSave = () => {
    setAutoSaveModal(false)
  }

  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField()
      if (resField?.data && resField?.data.length) {
        await saveDraft('');
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, '')();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };
  let resetInnoflex = () => {
    setInoflexReset([...innoflexResetIndex, activeInnoflexStage])
    let temp = [...innoflexList]
    {/* @ts-ignore */ }
    temp[activeInnoflexStage].Last_Saved_Date = null; temp[activeInnoflexStage].Phase_Start_Date = null; let name = innoflexStages[activeInnoflexStage]?.InnoflexPhasevalue
    setValue(name, null)
    setInnoflexList(temp)
    let optionnObj = innoflexQuestions
    {/* @ts-ignore */ }
    optionnObj.OptionsData.forEach(item => item.Innoflex_Phase_Options_Status = null)
    setInnoflexQuestions(optionnObj)
  }

  let resetSCPhase = () => {
    setScReset([...scResetIndex, activeScStage])
    let temp = [...scList]
    {/* @ts-ignore */ }
    let name = scStages[activeScStage].SCPhasevalue; temp[activeScStage].Last_Saved_Date = null; temp[activeInnoflexStage].Phase_Start_Date = null;
    setValue(name, null)
    setSClist(temp)
  }

  let handleAddBrands = () => {
    // @ts-ignore 
    if (formData.brandsInfo.list.filter((val) => !val.isDeleted).length == 6) return
    let obj = {
      "attributeId": null,
      "brand_key": "",
      "country_key": "",
      "Launch_Quarter": "",
      "Launch_Year": "",
      toSaveMileStone: false
    }
    let temp = [...formData.brandsInfo.list]
    temp.push(obj)
    setFormData({
      ...formData,
      brandsInfo: ({
        ...formData.brandsInfo,
        list: temp
      })
    })
  }

  let handleRemoveBrand = (index: any) => {
    let temp = [...formData.brandsInfo.list]
    // @ts-ignore
    temp[index].isDeleted = true
    setFormData({
      ...formData,
      brandsInfo: ({
        ...formData.brandsInfo,
        list: temp
      })
    })
  }

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");
    searchParams.delete("moduleId");
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };

  let handleCloseMilestoneModal = () => {
    setShowMilestoneModal(false)
  }

  let handleSubmitMilestoneModal = () => {
    setShowMilestoneModal(false)
  }

  let handleQuarterChange = (val: any) => {
    const year = formData.brandsInfo.list.find(item => item.toSaveMileStone)?.Launch_Year;
    fetchWeeks(year, val)
  }

  let handleYearChange = (val: any) => {
    const quarter = formData.brandsInfo.list.find(item => item.toSaveMileStone)?.Launch_Quarter;
    fetchWeeks(val, quarter)
  }

  return (
    <>
      <ToastContainer />
      <div className="create-project-content inform-content-lyt">
        <Card className="" sx={{ padding: "10px" }}>
          <CardContent>
            <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <>
                {
                  isUpload ?
                    <Stack

                      direction="row"
                      spacing={2}
                      sx={{ justifyContent: "start" }}
                    >
                      <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>

                    </Stack>
                    :
                    <Stack

                      direction="row"
                      spacing={2}
                      sx={{ justifyContent: "start" }}
                    >

                    </Stack>

                }


                {
                  !isUpload ?
                    <Stack

                      direction="row"
                      spacing={2}
                      sx={{ justifyContent: "end", pb: 4 }}
                    >
                      {
                        localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                          JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                            <Tooltip title="Upload Documents" arrow>
                              <Button
                                onClick={() => handleClickUpload()}
                                sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                              >
                                <img src={uploadIcon} className="icon-wt-uplad" />
                              </Button>
                            </Tooltip>
                            :
                            <>
                            </>
                          :
                          null
                      }

                      {

                        <Button disabled={isDisabled}
                          form="project-form"
                          // onClick={() => handleFormSubmit(true, '')}
                          onClick={() => saveProject('', true, appData.url)}
                          variant="contained"
                          sx={{
                            borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important',
                            backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}`

                          }}
                          className={classes.themeButton}>Submit</Button>

                      }
                      <Button
                        disabled={isDisabled || formData.issaved || issavedData}
                        onClick={() => saveDraft('')}
                        variant="contained"
                        sx={{
                          borderRadius: '30px',
                          px: 4,
                          py: 1,
                          textTransform: 'capitalize',
                          color: 'white !important',
                          backgroundColor: '#2a3fbf !important',
                          '&.Mui-disabled': {
                            backgroundColor: '#d9d9d9 !important',
                            color: '#5f6368 !important'
                          }
                        }}
                        className={classes.themeButton}
                      >
                        Draft & Continue
                      </Button>
                      <Button disabled={isDisabled} onClick={() => handleCancel()} variant="contained" sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize' }} className={classes.cancelButton}>Cancel</Button>
                    </Stack>
                    :
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                }


              </>

            </div>
            {
              isUpload ?
                <>
                  {/* @ts-ignore */}
                  <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={1}></UploadList>
                </>
                :
                <form id="project-form" noValidate >
                  <Grid container spacing={3}>
                    <Grid size={12}>
                      <h5 className="txt-mandatory-title">*Fields are mandatory</h5>
                    </Grid>
                    <Grid size={3}>
                      <label className="txt-label-input">Project Name<span className="required-txt">*</span></label>
                      <TextInput isDisabled={isDisabled} name="projectName" label="" control={control} errors={errors} onChange={(e) => handleFormChange(e.target.name, e.target.value)} isProjectName={true} />
                    </Grid>

                    <Grid size={3}>
                      <label className="txt-label-input">SC Lead<span className="required-txt">*</span></label>
                      <div className="project_drpdnw">
                        <Controller
                          name="scLead"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("scLead", val);
                                clearErrors("scLead");
                              }}
                              options={scLeads}
                              isError={!!errors.scLead}
                            />
                          )}
                        />
                      </div>
                      {errors.scLead && <p className="error-message">{errors.scLead.message}</p>}
                    </Grid>

                    <Grid size={3}>
                      <label className="txt-label-input">Business Unit<span className="required-txt">*</span></label>
                      <div className="project_drpdnw">
                        <Controller
                          name="buid"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("buid", val);
                                clearErrors("buid");
                                fetchGlobalFilters('buid', val)
                              }}
                              options={buids}
                              isError={errors.buid ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.buid && <p className="error-message">{errors.buid.message}</p>}
                    </Grid>

                    <Grid size={3}>
                      <label className="txt-label-input">Big Bet<span className="required-txt"></span></label>
                      <div className="project_drpdnw">
                        <Controller
                          name="bigBet"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              filterKey=""
                              label=""
                              value={field.value}
                              isDisabled={isDisabled}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("bigBet", val);
                                clearErrors("bigBet");
                              }}
                              options={bigBets}
                              isError={errors.bigBet ? true : false}

                            />
                          )}
                        />
                      </div>
                      {errors.bigBet && <p className="error-message">{errors.bigBet.message}</p>}
                    </Grid>
                    {/* 
                <Grid size={4}>
                  <label className="txt-label-input">Country<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="country"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("country", val);
                            clearErrors("country");
                            fetchGlobalFilters('country', val)
                          }}
                          options={countries}
                          isError={errors.country ? true : false}
                        />
                      )}
                    />
                  </div>

                  {errors.country && <p className="error-message">{errors.country.message}</p>}
                </Grid> */}

                    <Grid size={3}>
                      <label className="txt-label-input">Category <span className="required-txt">*</span></label>
                      <div className="project_drpdnw">
                        <Controller
                          name="category"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("category", val);
                                clearErrors("category");
                                fetchGlobalFilters('category', val)
                              }}
                              options={categories}
                              isError={errors.category ? true : false}

                            />
                          )}
                        />
                      </div>
                      {errors.category && <p className="error-message">{errors.category.message}</p>}
                    </Grid>
                    {/* <Grid size={4}>
                  <label className="txt-label-input">Brand Position<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="subCategory"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("subCategory", val);
                            clearErrors("subCategory");
                            fetchGlobalFilters('subCategory', val)
                          }}
                          options={subCategories}
                          isError={errors.subCategory ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.subCategory && <p className="error-message">{errors.subCategory.message}</p>}
                </Grid> */}

                    <Grid size={3}>
                      <label className="txt-label-input">Master Brand<span className="required-txt">*</span></label>
                      <div className="project_drpdnw">
                        <Controller
                          name="subCategory"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("subCategory", val);
                                clearErrors("subCategory");
                                fetchGlobalFilters('subCategory', val)
                              }}
                              options={subCategories}
                              isError={errors.subCategory ? true : false}

                            />
                          )}
                        />
                      </div>
                      {errors.subCategory && <p className="error-message">{errors.subCategory.message}</p>}
                    </Grid>


                    {/* <Grid size={4}>
                  <label className="txt-label-input">Brand<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="brand"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          filterKey=""
                          label=""
                          value={field.value}
                          isDisabled={isDisabled}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("brand", val);
                            clearErrors("brand");
                            fetchGlobalFilters('brand', val)
                          }}
                          options={brands}
                          isError={errors.brand ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.brand && <p className="error-message">{errors.brand.message}</p>}
                </Grid> */}

                    {/* <Grid size={4}>
                  <label className="txt-label-input">Launch Year<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="launchYear"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          filterKey=""
                          isDisabled={isDisabled}
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("launchYear", val);
                            clearErrors("launchYear");
                          }}
                          options={launchYears}
                          isError={errors.launchYear ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.launchYear && <p className="error-message">{errors.launchYear.message}</p>}
                </Grid> */}

                    {/* <Grid size={4}>
                  <label className="txt-label-input">Launch Quarter<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="launchWeek"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          filterKey=""
                          label=""
                          isDisabled={isDisabled}
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("launchWeek", val);
                            clearErrors("launchWeek");
                          }}
                          options={launchWeeks}
                          isError={errors.launchWeek ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.launchWeek && <p className="error-message">{errors.launchWeek.message}</p>}
                </Grid>
                 */}
                    <Grid size={3}>
                      <label className="txt-label-input">Project Status<span className="required-txt">*</span></label>
                      <div className="project_drpdnw">
                        <Controller
                          name="projectStatus"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              filterKey=""
                              label=""
                              value={field.value}
                              isDisabled={isDisabled}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("projectStatus", val);
                                clearErrors("projectStatus");
                              }}
                              options={projectStatus}
                              isError={errors.projectStatus ? true : false}

                            />
                          )}
                        />
                      </div>
                      {errors.projectStatus && <p className="error-message">{errors.projectStatus.message}</p>}
                    </Grid>

                  </Grid>
                  <Grid container spacing={3} mt={2}>
                    <Grid size={12}>
                      <div className="box-waplist-card">
                        <div className="table-responsive">
                          <table className="table tablechart-wts">
                            <thead className="thead-listwp">
                              <tr>
                                <th></th>
                                <th className="brands-info-heading" >Country </th>
                                <th className="brands-info-heading">Brand <span className="required-txt-wt">*</span></th>
                                <th className="brands-info-heading">Launch Year <span className="required-txt-wt">*</span></th>
                                <th className="brands-info-heading">Launch Quarter <span className="required-txt-wt">*</span></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.brandsInfo.list.map((val, index) => {
                                // @ts-ignore
                                if (val.isDeleted === true) return
                                return (
                                  <tr key={index}>
                                    <td>
                                      <label className="radio-button" title="Lead Market">
                                        <input
                                          disabled={isDisabled}
                                          type="radio"
                                          className="radio-button__input"
                                          name="choice1"
                                          checked={val.toSaveMileStone}
                                          onClick={() => {
                                            const updatedList = formData.brandsInfo.list.map((item, idx) => ({
                                              ...item,
                                              toSaveMileStone: idx === index
                                            }));
                                            setFormData({
                                              ...formData,
                                              brandsInfo: {
                                                ...formData.brandsInfo,
                                                list: updatedList,
                                                selectedBrand: index
                                              }
                                            });
                                            const year = formData.brandsInfo.list.length ? formData.brandsInfo.list[index]?.Launch_Year : ''
                                            const quarter = formData.brandsInfo.list.length ? formData.brandsInfo.list[index]?.Launch_Quarter : ''
                                            fetchWeeks(year, quarter)
                                          }}
                                        />
                                        <span className="radio-button__control"></span>
                                      </label>
                                    </td>
                                    <td>
                                      <div className="select-dropwap">
                                        <div className="project_drpdnw">
                                          <Controller
                                            name={`brandsInfo.list.${index}.country_key`}
                                            control={control}
                                            render={({ field }) => {
                                              return (
                                                <SelectDropdown
                                                  isDisabled={isDisabled}
                                                  filterKey=""
                                                  label=""
                                                  value={field.value || ""}
                                                  onChange={(val) => {
                                                    field.onChange(val);
                                                    const updatedList = [...formData.brandsInfo.list];
                                                    updatedList[index] = {
                                                      ...updatedList[index],
                                                      country_key: val
                                                    };
                                                    setFormData({
                                                      ...formData,
                                                      brandsInfo: {
                                                        ...formData.brandsInfo,
                                                        list: updatedList,
                                                        selectedBrand: index
                                                      }
                                                    });
                                                    clearErrors(`brandsInfo.list.${index}.country_key` as any);
                                                    // fetchGlobalFilters('country', val);
                                                  }}
                                                  options={countries}
                                                  isError={errors.brandsInfo?.list?.[index]?.country_key ? true : false}
                                                />
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="select-dropwap">
                                        <div className="project_drpdnw">
                                          <Controller
                                            name={`brandsInfo.list.${index}.brand_key` as any}
                                            control={control}
                                            render={({ field }) => {
                                              const currentCountry = formData.brandsInfo.list[index].country_key;
                                              const selectedBrandsForCountry = formData.brandsInfo.list
                                                .filter((_, idx) => idx !== index && _.country_key === currentCountry)
                                                .map(item => item.brand_key);
                                              const filteredBrands = brands ? brands.filter(
                                                // @ts-ignore 
                                                brand => !selectedBrandsForCountry.includes(String(brand.key))
                                              )
                                                :
                                                brands

                                              return (
                                                <SelectDropdown
                                                  filterKey=""
                                                  label=""
                                                  value={field.value}
                                                  isDisabled={isDisabled}
                                                  onChange={(val) => {
                                                    field.onChange(val);
                                                    const updatedList = [...formData.brandsInfo.list];
                                                    updatedList[index] = {
                                                      ...updatedList[index],
                                                      brand_key: val
                                                    };
                                                    setFormData({
                                                      ...formData,
                                                      brandsInfo: {
                                                        ...formData.brandsInfo,
                                                        list: updatedList
                                                      }
                                                    });
                                                    clearErrors(`brandsInfo.list.${index}.brand_key` as any);
                                                    //  fetchGlobalFilters('brand', val);
                                                  }}
                                                  options={filteredBrands}
                                                  isError={!!errors.brandsInfo?.list?.[index]?.brand_key}
                                                />
                                              );
                                            }}
                                          />
                                        </div>
                                        {/* @ts-ignore */}
                                        {errors.brandsInfo?.list?.[index]?.brand_key && <p className="error-message">{errors.brandsInfo?.list?.[index]?.brand_key.message}</p>}

                                      </div>
                                    </td>
                                    <td>
                                      <div className="select-dropwap">
                                        <div className="project_drpdnw">
                                          <Controller
                                            name={`brandsInfo.list.${index}.Launch_Year` as any}
                                            control={control}
                                            render={({ field }) => (
                                              <SelectDropdown
                                                filterKey=""
                                                isDisabled={isDisabled}
                                                label=""
                                                value={field.value}
                                                onChange={(val) => {
                                                  field.onChange(val);
                                                  const updatedList = [...formData.brandsInfo.list];
                                                  updatedList[index] = {
                                                    ...updatedList[index],
                                                    Launch_Year: val
                                                  };
                                                  setFormData({
                                                    ...formData,
                                                    brandsInfo: {
                                                      ...formData.brandsInfo,
                                                      list: updatedList
                                                    }
                                                  });
                                                  handleYearChange(val)
                                                  clearErrors(`brandsInfo.list.${index}.Launch_Year` as any);
                                                }}
                                                options={launchYears}
                                                isError={errors.brandsInfo?.list?.[index]?.Launch_Year ? true : false}
                                              />
                                            )}
                                          />
                                        </div>
                                        {/* @ts-ignore */}
                                        {errors.brandsInfo?.list?.[index]?.Launch_Year && <p className="error-message">{errors.brandsInfo?.list?.[index]?.Launch_Year.message}</p>}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="select-dropwap">
                                        <div className="project_drpdnw">
                                          <Controller
                                            name={`brandsInfo.list.${index}.Launch_Quarter` as any}
                                            control={control}
                                            render={({ field }) => (
                                              <SelectDropdown
                                                filterKey=""
                                                label=""
                                                isDisabled={isDisabled}
                                                value={field.value}
                                                onChange={(val) => {
                                                  field.onChange(val);
                                                  const updatedList = [...formData.brandsInfo.list];
                                                  updatedList[index] = {
                                                    ...updatedList[index],
                                                    Launch_Quarter: val
                                                  };
                                                  setFormData({
                                                    ...formData,
                                                    brandsInfo: {
                                                      ...formData.brandsInfo,
                                                      list: updatedList
                                                    }
                                                  });
                                                  clearErrors(`brandsInfo.list.${index}.Launch_Quarter` as any);
                                                  handleQuarterChange(val)
                                                }}
                                                options={launchWeeks}
                                                isError={errors.brandsInfo?.list?.[index]?.Launch_Quarter ? true : false}
                                              />
                                            )}
                                          />
                                        </div>
                                        {/* @ts-ignore */}
                                        {errors.brandsInfo?.list?.[index]?.Launch_Quarter && <p className="error-message">{errors.brandsInfo?.list?.[index]?.Launch_Quarter.message}</p>}
                                      </div>
                                    </td>
                                    {
                                      localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                                        JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                                          <>
                                            <td>
                                              <div className="action-flx-icon">
                                                <Button
                                                  variant="contained"
                                                  sx={{
                                                    borderRadius: "50%",
                                                    minWidth: 32,
                                                    width: 32,
                                                    height: 31,
                                                    paddingTop: 1,
                                                    marginRight: '2px',
                                                    // @ts-ignore 
                                                    backgroundColor: formData.brandsInfo.list.filter((val) => !val.isDeleted).length >= 6 ? "#d9d9d9" : "#72ded9",
                                                    color: "#000",
                                                    fontWeight: "bold",
                                                    fontSize: "22px",
                                                    lineHeight: 1,
                                                    "&:hover": {
                                                      // @ts-ignore 
                                                      backgroundColor: formData.brandsInfo.list.filter((val) => !val.isDeleted).length >= 6 ? "#d9d9d9" : "#72ded9",
                                                    },
                                                    // padding: 0,
                                                  }}
                                                  onClick={handleAddBrands}
                                                >
                                                  +
                                                </Button>

                                                {
                                                  val?.toSaveMileStone === false ?

                                                    <Button
                                                      variant="contained"
                                                      sx={{
                                                        borderRadius: "50%",
                                                        minWidth: 32,
                                                        width: 32,
                                                        height: 31,
                                                        paddingTop: 0.5,
                                                        lineheight: 40,
                                                        backgroundColor: "#f2a5a9",   // light red
                                                        color: "#000",                // black text
                                                        fontWeight: "bold",
                                                        fontSize: "24px",             // bigger dash
                                                        lineHeight: 1,
                                                        "&:hover": {
                                                          backgroundColor: "#f2a5a9",
                                                        },
                                                        // padding: 0,
                                                      }}
                                                      onClick={() => handleRemoveBrand(index)}
                                                    >
                                                      -
                                                    </Button>
                                                    :
                                                    null
                                                }
                                              </div>
                                            </td>
                                          </>
                                          :
                                          <>
                                          </>
                                        :
                                        <>
                                        </>


                                    }

                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Grid>
                  </Grid>


                  <Grid container spacing={3} mt={2}>
                    <Grid size={4}>
                      <Grid container spacing={2}>
                        <Grid size={4}>
                          <label className="txt-label-input">Upload Pic<span className="required-txt"></span></label>
                          <div className="file-upload-button">
                            <FileUpload isDisabled={isDisabled} onFileChange={handleFileChange}
                              name="uploadPic" label="Browse" control={control} errors={errors} />
                          </div>
                        </Grid>
                        {
                          imagePreview ?
                            <Grid size={8}>
                              <div className="upload-image-preview">
                                <img src={imagePreview} alt="product" />
                                <span onClick={handleRemoveImg} className="cross-img-btn">x</span>
                              </div>
                            </Grid>
                            :
                            null
                        }

                      </Grid>

                    </Grid>
                  </Grid>
                  <Stack sx={{ height: "1px", backgroundColor: "#0000003b", my: 3 }}></Stack>
                  <Grid container spacing={2} mt={2}>
                    <Grid size={8}>

                      <Typography className="txt-label-input">Format<span className="required-txt">*</span></Typography>
                      <div className="project_drpdnwFormat">
                        <Controller
                          name="format"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("format", val);
                                clearErrors("format");
                              }}
                              options={formats}
                              isError={errors.format ? true : false}

                            />
                          )}
                        />
                      </div>
                      {errors.format && <p className="error-message">{errors.format.message}</p>}
                      <Grid container spacing={1} mt={2}>
                        {/* SC Phase */}
                        <div className="scformate-v2">
                          <Typography fontSize="20" fontWeight="bold" className="txt-label-input">SC Phase</Typography>
                          <Stack sx={{ alignItems: "start" }}>
                            <ul className="inno-fx">
                              {
                                scList.length ?
                                  scStages.map((val, i) => {
                                    return (

                                      <li className="items-buton-ph">
                                        {/* @ts-ignore */}
                                        <Stack className={`${scList[i].Last_Saved_Date ? 'active-inno' : ''}`} sx={{ borderRadius: "30px", backgroundColor: "#d9d9d9", color: "#8c8c8c", padding: "8px 20px", marginRight: "5px", fontSize: "13px" }}>{val.SCPhasevalue}</Stack>
                                        <span>
                                          {
                                            // @ts-ignore 
                                            scList[i].Phase_Start_Date ? formatDate(scList[i].Phase_Start_Date) : ''
                                          }
                                        </span>
                                      </li>

                                    )
                                  })
                                  :
                                  null
                              }
                            </ul>
                            <br></br>
                            <div onClick={() => openScdModal()} className="items-vl-wp-v2">
                              Select SC Phase
                              {/* <span className="form-button-vl">
                            <img style={{ width: '25px', height: '25px' }} src={QnAIcon} />
                          </span> */}
                            </div>
                          </Stack>
                        </div>
                        {/* Innoflex Phase */}
                        <div className="innoflexformate-v2" >
                          <Typography fontSize="20" fontWeight="bold" className="txt-label-input">Innoflex Phase</Typography>
                          <Stack sx={{ alignItems: "start" }}>
                            <ul className="inno-fx">
                              {
                                innoflexList.length ?
                                  innoflexStages.map((val, index) => {
                                    // console.log(" innoflexList[index].Last_Saved_Date",  innoflexList[index].Last_Saved_Date)
                                    return (

                                      <li className="items-buton-ph ">
                                        {/* @ts-ignore */}
                                        <Stack className={`${innoflexList[index].Last_Saved_Date ? 'active-inno' : ''}`} sx={{ borderRadius: "30px", backgroundColor: "#d9d9d9", color: "#8c8c8c", padding: "8px 20px", marginRight: "5px", fontSize: "13px" }}>{val.InnoflexPhasevalue}</Stack>
                                        <span>
                                          {
                                            // @ts-ignore 
                                            innoflexList[index].Phase_Start_Date ? formatDate(innoflexList[index].Phase_Start_Date) : ''
                                          }
                                        </span>
                                      </li>
                                    )
                                  })
                                  :
                                  null
                              }
                            </ul>
                            <br></br>
                            <div onClick={handleClickOpen} className="items-vl-wp-v2">
                              Select Innoflex Phase & Checklist
                              {/* <span className="form-button-vl">
                            <img style={{ width: '25px', height: '25px' }} src={QnAIcon} />
                          </span> */}
                            </div>
                          </Stack>
                        </div>


                        {/* Comment Field */}
                      </Grid>
                    </Grid>

                    <Grid size={4}>
                      <div className="form-formate">
                        <label className="txt-label-input">Project Exceptions<span className="required-txt"></span></label>
                        <TextInput isDisabled={isDisabled} className="project-exception-input" isComment={{ enabled: true, maxLength: 1000 }} onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="projectExpectation" label="" control={control} errors={errors} multiline
                        />
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} mt={1}>
                    <Grid size={8}>
                      <div className="form-formate">
                        <Typography className="txt-label-input">Comment</Typography>
                        <TextInput className="comment-input" isComment={true} isDisabled={isDisabled} onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="comment" label="" control={control} errors={errors} multiline />
                      </div>
                    </Grid>
                    <Grid size={4}>
                      <div className="form-formate">
                        <Typography className="txt-label-input">Project Risk</Typography>
                        <div className="project_drpdnw">
                          <Controller
                            name="risk"
                            control={control}
                            render={({ field }) => (
                              <SelectDropdown
                                filterKey=""
                                label=""
                                value={field.value}
                                isDisabled={isDisabled}
                                onChange={(val) => {
                                  field.onChange(val);
                                  handleFilterChange("risk", val);
                                  clearErrors("risk");
                                }}
                                options={risks}
                                isError={errors.risk ? true : false}

                              />
                            )}
                          />
                        </div>
                        {errors.risk && <p className="error-message">{errors.risk.message}</p>}
                      </div>
                    </Grid>
                  </Grid>
                </form>
            }

          </CardContent>
        </Card>
      </div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="overFlow-modal-visible"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <span className="modal-title-ht">Innoflex Phase</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ overflowY: "visible" }}>
          <div className="date-relative-card">
            <Grid container spacing={1}>
              {
                innoflexStages.length ?
                  innoflexStages && innoflexList.map((cal, cli) => {
                    {/* @ts-ignore */ }
                    let name = innoflexStages[cli]?.InnoflexPhasevalue
                    return (
                      <Grid sx={{ maxWidth: '150px', mb: 2, position: "relative" }}>
                        <Controller
                          name={name}
                          control={control}
                          render={({ field, fieldState: { error } }) => (
                            <TextField
                              {...field}
                              fullWidth
                              label=""
                              id=""
                              value={field.value || ''}
                              sx={{ input: { backgroundColor: '#fff', borderRadius: "20px", height: "17px !important" } }}
                              onKeyDown={(e) => e.preventDefault()}
                              error={!!error}
                              helperText={error ? error.message : ""}
                            />
                          )}
                        />
                        {/* @ts-ignore */}
                        <span className={`icon-date dateIcon-samll ${(cal.Innoflex_Phase_Key != activeInnoflexStage + 1) || (cal?.Phase_Start_Date) ? 'disabled' : ''}`} onClick={() => toggleCalendar(`${name}x`, cal, 'innoflex')}>
                          <i className="fas fa-calendar-alt"></i>
                        </span>
                        {openCalendar == `${name}x` && (
                          // @ts-ignore
                          <DateCalendarValue dateValue={watch(name)} onDateSelect={(date) => handleDateSelect(date, name)}
                            onClose={() => setOpenCalendar(null)}
                          />
                        )}
                      </Grid>
                    )
                  })
                  :
                  null
              }
              <Tooltip title="Reset Innoflex Data" arrow>
                <IconButton
                  onClick={resetInnoflex}
                  sx={{
                    backgroundColor: "#0A53C2", // Blue background
                    color: "#fff", // White icon
                    borderRadius: "50%", // Ensures a circular shape
                    width: "32px", // Explicit width
                    height: "32px", // Explicit height
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px", // Adjust padding to avoid square effect
                    "&:hover": {
                      backgroundColor: "#0849A3", // Darker blue on hover
                    },
                  }}
                >
                  <Refresh />
                </IconButton>
              </Tooltip>

            </Grid>
            <Grid container spacing={1}>
              {
                innoflexStages.length ?
                  innoflexList.map((val, idx) => {
                    return (

                      <Grid sx={{ width: '150px', mb: 2 }}>
                        {/* @ts-ignore */}
                        <span onClick={() => setActiveInnoflexStage(idx)} className={`innof-flex-button ${activeInnoflexStage == idx ? 'active' : ""}`}>{innoflexStages[idx].InnoflexPhasevalue}</span>
                      </Grid>

                    )
                  })
                  :
                  null
              }

            </Grid>

            <Grid container spacing={2}>

              <Grid size={12}>
                <div className="phaes_tbl_cn">
                  <TableContainer sx={{ overFlow: 'auto' }}>
                    <Table aria-label="simple table" sx={{ border: 0, borderRadius: "0px", overflow: "auto" }}>
                      <TableHead>
                        <TableRow sx={{ th: { border: 0, backgroundColor: "#d9d9d9", py: 1 } }}>
                          <TableCell sx={{ width: "20px" }}>S.No</TableCell>
                          <TableCell>Milestones</TableCell>
                          <TableCell sx={{ width: "170px", '&:last-child': { borderLeft: "2px solid #d0d0d0" } }}>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          // @ts-ignore
                          innoflexQuestions && innoflexQuestions.OptionsData ?
                            // @ts-ignore
                            innoflexQuestions.OptionsData.map((val, i) => {
                              return (
                                <TableRow sx={{ td: { border: 0 } }}
                                >

                                  <TableCell sx={{ fontSize: "13px", py: 1 }}>{i + 1}</TableCell>
                                  {/* @ts-ignore */}
                                  <TableCell sx={{ fontSize: "13px", py: 1 }}>{val.Milestone}</TableCell>
                                  <TableCell sx={{ fontSize: "13px", py: 1, '&:last-child': { borderLeft: "2px solid #d0d0d0" } }}>
                                    <div className="action-br">
                                      {/* <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, true)} className={`wt-ys-card ${val.Innoflex_Phase_Options_Status == true ? 'active-inno' : ''}`}>Yes</span>
                                      <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, false)} className={`wt-ys-card ${val.Innoflex_Phase_Options_Status == false ? 'active-inno' : ''}`}>No</span> */}
                                      <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, 1)} className={`wt-ys-card ${val.Innoflex_Phase_Options_Status === 1 ? 'active-inno' : ''}`}>Yes </span>
                                      <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, 2)} className={`wt-ys-card ${val.Innoflex_Phase_Options_Status === 2 ? 'active-inno' : ''}`}>No </span>
                                      <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, 3)} className={`wt-ys-card ${val.Innoflex_Phase_Options_Status === 3 ? 'active-inno' : ''}`}> NA</span>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              )
                            })
                            :
                            null
                        }

                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus sx={{ backgroundColor: "#d9d9d9", borderRadius: "30px", color: "#535151", width: "120px", mr: 2 }} onClick={handleClose}>Cancel</Button>
          <Button onClick={handleInnoflexSave} sx={{ backgroundColor: "#2a3fbf", borderRadius: "30px", color: "#fff", width: "120px" }}>Save</Button>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapSCDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={scOpen}
        className="overFlow-modal-visible"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <span className="modal-title-ht">SC Phase </span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setScOpen(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ overflowY: "visible" }}>
          <div className="date-relative-card">
            <Grid container spacing={1}>
              {
                scStages.map((cal, cli) => {
                  {/* @ts-ignore */ }
                  let name = cal.SCPhasevalue
                  return (
                    <Grid sx={{ maxWidth: '150px', mb: 2, position: "relative" }}>
                      <Controller
                        name={name}
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            {...field}
                            fullWidth
                            label=""
                            id=""
                            value={field.value || ''}
                            sx={{ input: { backgroundColor: '#fff', borderRadius: "20px", height: "17px !important" } }}
                            onKeyDown={(e) => e.preventDefault()}
                            error={!!error}
                            helperText={error ? error.message : ""}
                          />
                        )}
                      />
                      {/* @ts-ignore */}
                      <span className={`icon-date dateIcon-samll ${(cal.SCPhase_key != activeScStage + 1) || (cal?.Phase_Start_Date) ? 'disabled' : ''}`} onClick={() => toggleCalendar(`${name}x`, cal, 'sc')}>
                        <i className="fas fa-calendar-alt"></i>
                      </span>
                      {openCalendar == `${name}x` && (
                        // @ts-ignore
                        <DateCalendarValue dateValue={watch(name)} onDateSelect={(date) => handleDateSelect(date, name)}
                          onClose={() => setOpenCalendar(null)}
                        />
                      )}
                    </Grid>
                  )
                })
              }
              {/* <Grid>
                <Button onClick={resetSCPhase} sx={{ backgroundColor: "#2a3fbf", borderRadius: "30px", color: "#fff", width: "120px" }}>Reset</Button>
              </Grid> */}
              <Tooltip title="Reset SC Phase Data" arrow>
                <IconButton
                  onClick={resetSCPhase}
                  sx={{
                    backgroundColor: "#0A53C2", // Blue background
                    color: "#fff", // White icon
                    borderRadius: "50%", // Ensures a circular shape
                    width: "32px", // Explicit width
                    height: "32px", // Explicit height
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px", // Adjust padding to avoid square effect
                    "&:hover": {
                      backgroundColor: "#0849A3", // Darker blue on hover
                    },
                  }}
                >
                  <Refresh />
                </IconButton>
              </Tooltip>

            </Grid>
            <Grid container spacing={1}>
              {
                scStages.map((val, idx) => {
                  return (

                    <Grid sx={{ width: '150px', mb: 2 }}>
                      {/* @ts-ignore */}

                      <span onClick={() => setActiveScStage(idx)} className={`innof-flex-button ${activeScStage == idx ? 'active' : ""}`}>{val.SCPhasevalue}</span>
                    </Grid>

                  )
                })
              }

            </Grid>

          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus sx={{ backgroundColor: "#d9d9d9", borderRadius: "30px", color: "#535151", width: "120px", mr: 2 }} onClick={() => setScOpen(false)}>Cancel</Button>
          <Button onClick={() => handleScSave()} sx={{ backgroundColor: "#2a3fbf", borderRadius: "30px", color: "#fff", width: "120px" }}>Save</Button>
        </DialogActions>
      </BootstrapSCDialog>

      {/* @ts-ignore */}
      <InnoflexSaveModal open={innoflexSuccessModal} /> <DeleteModal open={false} />  <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />
      {/* @ts-ignore */}
      <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} isDraftDisabled={isDraftDisabled} /> <AutoSaveModal open={autoSaveModal} closeAutoSave={closeAutoSave} autoSave={autoSave} ></AutoSaveModal>


      {/* Milestone modal */}
      <Dialog open={showMilestoneModal} onClose={() => handleCloseMilestoneModal()} maxWidth="xs" fullWidth>

        <DialogTitle style={{ color: '#0052CC', fontWeight: 'bold', borderBottom: '1px solid #ccc' }}>
          Select Launch Week <br />
        </DialogTitle>

        <DialogContent>
          <form >
            <Grid container spacing={3} sx={{ paddingTop: "10px" }}>

              {/* Project Name */}
              <Grid size={12} className="select-launch-form">
                <label className='projectnamedisplaylabel'>Launch Year <label className='feelfreetext'></label> <span style={{ color: 'red' }}>*</span></label>
                <Controller
                  name={`brandsInfo.list.${formData.brandsInfo.selectedBrand}.Launch_Year` as any}
                  control={control}
                  render={({ field }) => (
                    <SelectDropdown
                      filterKey=""
                      isDisabled={true}
                      label=""
                      value={field.value}
                      onChange={(val) => {
                        field.onChange(val);
                        const updatedList = [...formData.brandsInfo.list];
                        updatedList[formData.brandsInfo.selectedBrand] = {
                          ...updatedList[formData.brandsInfo.selectedBrand],
                          Launch_Year: val
                        };
                        setFormData({
                          ...formData,
                          brandsInfo: {
                            ...formData.brandsInfo,
                            list: updatedList
                          }
                        });
                        handleYearChange(val)
                        clearErrors(`brandsInfo.list.${formData.brandsInfo.selectedBrand}.Launch_Year` as any);
                      }}
                      options={launchYears}
                      isError={errors.brandsInfo?.list?.[formData.brandsInfo.selectedBrand]?.Launch_Year ? true : false}
                    />
                  )}
                />
              </Grid>

              {/* Country Dropdown */}
              <Grid size={12} className="select-launch-form">
                <label className='projectnamedisplaylabel'>Launch Week <span style={{ color: 'red' }}>*</span></label>
                <Controller
                  name={`brandsInfo.list.${0}.country_key`}
                  control={control}
                  render={({ field }) => {

                    return (
                      <SelectDropdown
                        isDisabled={false}
                        filterKey=""
                        label=""
                        value={field.value || ""}
                        onChange={(val) => {
                          setMilestoneData({
                            ...mileStoneData,
                            // @ts-ignore
                            Launch_Week: parseInt(val)
                          });
                        }}
                        options={launchWeeksOption}
                      />
                    );
                  }}
                />
              </Grid>
              {/* Buttons */}
              <Grid size={6}>
                <Button onClick={handleCloseMilestoneModal} variant="outlined" color="secondary" fullWidth style={{ backgroundColor: '#ccc', color: '#000', borderRadius: '20px', border: '1px solid #999', fontSize: "13px" }} >
                  Cancel
                </Button>
              </Grid>
              <Grid size={6}>
                <Button
                  disabled={!mileStoneData.Launch_Week}
                  sx={{
                    borderRadius: '30px',
                    px: 4,
                    py: 1,
                    textTransform: 'capitalize',
                    color: 'white !important',
                    backgroundColor: '#2a3fbf !important',
                    '&.Mui-disabled': {
                      backgroundColor: '#d9d9d9 !important',
                      color: '#5f6368 !important'
                    }
                  }}
                  onClick={() => saveProjectwithMileStone()} variant="contained" style={{ backgroundColor: '#2A3FBF', color: '#fff', borderRadius: '20px', fontSize: "13px" }} fullWidth>
                  Proceed
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </>

  );
};

export default ProjectForm;
